<template>
  <div
    class="bar-spacer"
  />
</template>

<style scoped lang="scss">
.bar-spacer {
  flex: 1;
  min-height: 0;
}
</style>
